import React, {useEffect} from 'react'
import {Box, Button, Grid, IconButton, Container, Typography} from '@material-ui/core/'
import CloseIcon from '@material-ui/icons/Close'
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import EditBarcodeTemplate from './BarcodeLibraryEditTemplate'
import EditBarcodeSheet from './BarcodeLibraryEditSheet'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryEditDrawer.styles'

export default function BarcodeLibraryEditDrawer(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [disableButton, setDisableButtons] = React.useState(false)

  function closeDrawer(event) {
    props.toggleDrawer(false)
  }

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  function drawerTitle() {
    let title = ''
    let subTitle = ''
    let template = ''
    switch (props.showTable) {
      case 'automated':
      case 'fieldValue':
        title = t('barcode.library.edit-drawer.edit-template')
        subTitle = t('barcode.library.edit-drawer.template-details')
        template = (
          <EditBarcodeTemplate
            record={props.record}
            labelsRecord={props.labelsRecord}
            showTable={props.showTable}
            disableButton={setDisableButtons}
          />
        )
        break
      case 'sheets':
        title = t('barcode.library.edit-drawer.edit-sheet')
        subTitle = t('barcode.library.edit-drawer.sheet-details')
        template = (
          <EditBarcodeSheet
            record={props.record}
            showTable={props.showTable}
            disableButton={setDisableButtons}
          />
        )
        break
      case 'labels':
        title = t('barcode.library.edit-drawer.edit-label')
        subTitle = t('barcode.library.edit-drawer.label-details')
        break
      default:
        title = t('barcode.library.edit-drawer.error-loading')
        subTitle = t('barcode.library.edit-drawer.error-encountered')
        break
    }

    if (!props.record.accountId && props.showTable === 'sheets') {
      title = t('barcode.library.edit-drawer.view-template')
      subTitle = t('barcode.library.edit-drawer.view-details')
    }

    return (
      <div>
        <Typography variant="h6">{title}</Typography>
        <Box fontSize={12} fontWeight={200} marginTop={2} marginBottom={3}>
          {subTitle}
        </Box>
        {template}
      </div>
    )
  }

  return (
    <div className={classes.list} role="presentation">
      <Grid container>
        <Grid container item xs={9} justify="flex-start">
          <Button className={classes.backBtn} onClick={closeDrawer} disabled={disableButton}>
            <ArrowLeftIcon />
            {t('barcode.library.edit-drawer.back-to-library')}
          </Button>
        </Grid>

        <Grid container item xs={3} justify="flex-end">
          <IconButton className={classes.buttonLink} onClick={closeDrawer} disabled={disableButton}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Container>
        {drawerTitle()}
        <Box marginTop={2} />
        <Grid container item xs={12} justify="flex-start">
          <Button
            value="save-template"
            variant="outlined"
            fullWidth={true}
            onClick={closeDrawer}
            disabled={disableButton}
            style={{textTransform: 'none'}}
          >
            {t('barcode.library.edit-drawer.cancel')}
          </Button>
        </Grid>
        <Box marginBottom={5} />
      </Container>
    </div>
  )
}
